// extracted by extract-css-chunks-webpack-plugin
module.exports = {"trigger":"_2_0Nz8","trigger-with-background":"_1s03OM"};